import { render, staticRenderFns } from "./ArchiveInventoryUpdateModal.vue?vue&type=template&id=245c8c28&scoped=true&"
import script from "./ArchiveInventoryUpdateModal.vue?vue&type=script&lang=js&"
export * from "./ArchiveInventoryUpdateModal.vue?vue&type=script&lang=js&"
import style0 from "./ArchiveInventoryUpdateModal.vue?vue&type=style&index=0&id=245c8c28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245c8c28",
  null
  
)

component.options.__file = "ArchiveInventoryUpdateModal.vue"
export default component.exports